import React from 'react';

// Branded product name component with consistent styling
// Bold prefix + light suffix

export const BrandedProductName = ({ product, className = "" }) => {
  switch (product) {
    case 'OMNIAGENCY':
    case 'OmniAgency':
      return (
        <span className={className}><span className="font-black">OMNI</span><span className="font-extralight">AGENCY</span></span>
      );
    case 'OMNISCOUTING':
    case 'OmniScouting':
      return (
        <span className={className}><span className="font-black">OMNI</span><span className="font-extralight">SCOUTING</span></span>
      );
    case 'OMNIATHLETICS':
    case 'OmniAthletics':
      return (
        <span className={className}><span className="font-black">OMNI</span><span className="font-extralight">ATHLETICS</span></span>
      );
    case 'OMNIDRAFTLAB':
    case 'OmniDraftLab':
      return (
        <span className={className}><span className="font-black">OMNI</span><span className="font-extralight">DRAFTLAB</span></span>
      );
    case 'VERIFIED':
      return (
        <span className={className}><span className="font-black">VERIFIED</span></span>
      );
    case 'THE DOSSIER':
      return (
        <span className={className}><span className="font-black">THE </span><span className="font-extralight">DOSSIER</span></span>
      );
    case 'PLAYERSINC':
    case 'Players Inc':
      return (
        <span className={className}><span className="font-black">PLAYERS</span><span className="font-extralight">INC</span></span>
      );
    default:
      return <span className={className}>{product}</span>;
  }
};

// Simple text version for places where JSX component doesn't work well
export const getProductNameParts = (product) => {
  switch (product) {
    case 'OMNIAGENCY':
      return { bold: 'OMNI', light: 'AGENCY' };
    case 'OMNISCOUTING':
      return { bold: 'OMNI', light: 'SCOUTING' };
    case 'OMNIATHLETICS':
      return { bold: 'OMNI', light: 'ATHLETICS' };
    case 'OMNIDRAFTLAB':
      return { bold: 'OMNI', light: 'DRAFTLAB' };
    case 'VERIFIED':
      return { bold: 'VERIFIED', light: '' };
    case 'THE DOSSIER':
      return { bold: 'THE ', light: 'DOSSIER' };
    case 'PLAYERSINC':
      return { bold: 'PLAYERS', light: 'INC' };
    default:
      return { bold: product, light: '' };
  }
};

export default BrandedProductName;
